export default "__VITE_ASSET__5e40d3e2__"